import script from "./UiIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./UiIcon.vue?vue&type=script&setup=true&lang=js"

import "./UiIcon.vue?vue&type=style&index=0&id=269291ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-269291ce"]])

export default __exports__